// extracted by mini-css-extract-plugin
export var blue1 = "rgb(44, 82, 139)";
export var col0 = "index-module--col0--msFDM";
export var cols = "index-module--cols--kYCG1 flex";
export var couture = "index-module--couture--tcVwl";
export var defense = "index-module--defense--gtWh9";
export var eason = "EasonPro, \"Times New Roman\", serif";
export var eq = "index-module--eq--h-BtP";
export var gpHeader = "index-module--gpHeader--ZnFnJ";
export var gpItem = "index-module--gpItem--LbR0q";
export var gpList = "index-module--gpList--O+qTu";
export var green1 = "rgb(0, 132, 56)";
export var lu = "index-module--lu--V3GoP";
export var mqMaxMd = "screen and (max-width: 48em)";
export var mqMinMd = "screen and (min-width: 48em)";
export var para0 = "index-module--para0--uXynb col intro";
export var tan1 = "rgb(160, 130, 68)";